import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
export default {
  name: "code",
  computed: {
    ...walletVuex.mapState(["isMobile", "theme"])
  },
  data() {
    return {
      popGetAwaitShow: false
    };
  },
  beforeRouteLeave(to, from, next) {
    try {
      this.popGetAwaitShow = false;
    } catch (error) {}
    this.$nextTick(() => {
      next();
    });
  },
  methods: {
    onClaim() {
      this.popGetAwaitShow = true;
    }
  }
};